(function () {
    'use strict';
    /*
     * Copyright (c) 2017 In Hand Health.
     * All rights reserved.
     */

    /**
     * A service for common item chooser operations for person-like individuals.
     * @ngdoc service
     * @memberOf ihh-common-web
     * @name IndividualHelper
     */
    angular
        .module('ihh-common-web')
        .service('IndividualHelper', IndividualHelper);

    IndividualHelper.$inject = ['ItemChooserConstants'];

    function IndividualHelper(ItemChooserConstants) {
        /*
         * Sets up static settings for listing individuals of different kinds.
         * @ngdoc method
         * @memberOf ihh-common-web.IndividualHelper
         * @name setupIndividualPicker
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config} config the config object to modify
         * @param {String} singularName the singular name for the kind of individual
         * @param {String} pluralName the plural name for the kind of individual
         */
        this.setupIndividualPicker = function (config, singularName, pluralName) {
            config.setItemProperties(singularName, pluralName, true);

            config.addFilterOption('loggedin', 'Logged In', 'display', 'hasLoggedIn', 'hasLoggedIn', 'display', ItemChooserConstants.YES_NO_VALUES);

            addNameSorts(config);
            config.addSortOption(ItemChooserConstants.SORT_KIND_CUSTOM, 'Most Recent', 'recent');
            config.addSortOption(ItemChooserConstants.SORT_KIND_CUSTOM, 'Last Login', 'login');
        };

        /*
         * Sets up a trio of Active, Inactive, and All options for an individual that has an <code>active</code> attribute.
         * @ngdoc method
         * @memberOf ihh-common-web.IndividualHelper
         * @name setupActiveWho
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config} config the config object to modify
         */
        this.setupActiveWho = function (config) {
            config.addWho('all', 'All', {}, false);

            config.addWho('active', 'Active', {
                active: true
            }, false);

            config.addWho('inactive', 'Inactive', {
                active: false
            }, false);
        };

        /*
         * Adds first and last name sorts to the picker.
         * @ngdoc method
         * @memberOf ihh-common-web.IndividualHelper
         * @name addNameSorts
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config} config the config object to modify
         */
        function addNameSorts(config) {
            config.addSortOption(ItemChooserConstants.SORT_KIND_ALPHA, 'Last Name', ['lastName']);
            config.addSortOption(ItemChooserConstants.SORT_KIND_ALPHA, 'First Name', ['firstName']);
        }
    }
})();
